module.exports = __webpack_public_path__ + "static/media/second-pos.4e0386c6.svg";